import { Authorisation } from "@iventis/domain-model/model/authorisation";
import { User } from "@iventis/domain-model/model/user";
import { UserGroup } from "@iventis/domain-model/model/userGroup";
import { UserGroupWithUsers } from "@iventis/domain-model/model/userGroupWithUsers";
import { Toasts } from "@iventis/toasts/src/toast.types";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";

export interface TeamsViewMachineContext {
    teams: UserGroupWithUsers[];
    teamForPersonAddition: UserGroupWithUsers;
    personRemovalFromTeamSelection: { team: UserGroup; person: User };
    expandedTeams: string[];
    personToUpdateLeader: { teamId: string; userId: string; authorisation: Authorisation };
    teamToDelete: UserGroup;
    translate: UseIventisTranslate;
    toast: Toasts;
}

export enum TeamsViewMachineEvent {
    EXPAND = "EXPAND",
    COLLAPSE = "COLLAPSE",
    ADD_PEOPLE_TO_TEAM = "ADD_PEOPLE_TO_TEAM",
    TEAM_SELECTED_FOR_PERSON_ADDITION = "TEAM_SELECTED_FOR_PERSON_ADDITION",
    REQUEST_UPDATE_TEAM_LEADER = "REQUEST_UPDATE_TEAM_LEADER",
    UPDATE_TEAM_LEADER = "UPDATE_TEAM_LEADER",
    CANCEL_TEAM_LEADER = "CANCEL_TEAM_LEADER",
    SET_PERSON_FOR_TEAM_REMOVAL = "SET_PERSON_FOR_TEAM_REMOVAL",
    REMOVE_PERSON_FROM_TEAM = "REMOVE_PERSON_FROM_TEAM",
    CREATE_TEAM = "CREATE_TEAM",
    SAVE_NEW_TEAM = "SAVE_NEW_TEAM",
    CANCEL_CREATE_TEAM = "CANCEL_CREATE_TEAM",
    DELETE_TEAM = "DELETE_TEAM",
    CANCEL_DELETE_TEAM = "CANCEL_DELETE_TEAM",
    CONFIRM_DELETE_TEAM = "CONFRIM_DELETE_TEAM",
}

export interface ExpandTeamEvent {
    type: typeof TeamsViewMachineEvent.EXPAND;
    payload: string;
}

export interface CollapseTeamEvent {
    type: typeof TeamsViewMachineEvent.COLLAPSE;
    payload: string;
}

export interface AddPeopleToTeamEvent {
    type: typeof TeamsViewMachineEvent.ADD_PEOPLE_TO_TEAM;
    payload: { teamId: string; people: User[] };
}

export interface RequestUpdateTeamLeaderEvent {
    type: typeof TeamsViewMachineEvent.REQUEST_UPDATE_TEAM_LEADER;
    payload: { teamId: string; userId: string; authorisation: Authorisation };
}

export interface UpdateTeamLeaderEvent {
    type: typeof TeamsViewMachineEvent.UPDATE_TEAM_LEADER;
    payload: { teamId: string; userId: string; authorisation: Authorisation };
}

export interface CancelTeamLeaderEvent {
    type: typeof TeamsViewMachineEvent.CANCEL_TEAM_LEADER;
}

export interface TeamSelectedForPersonAdditionEvent {
    type: typeof TeamsViewMachineEvent.TEAM_SELECTED_FOR_PERSON_ADDITION;
    payload: { team: UserGroupWithUsers };
}

export interface SetPersonForTeamRemovalEvent {
    type: typeof TeamsViewMachineEvent.SET_PERSON_FOR_TEAM_REMOVAL;
    payload: { team: UserGroup; person: User };
}

export interface RemovePersonFromTeamEvent {
    type: typeof TeamsViewMachineEvent.REMOVE_PERSON_FROM_TEAM;
    payload: { team: UserGroup; person: User };
}

export interface CreateTeamEvent {
    type: typeof TeamsViewMachineEvent.CREATE_TEAM;
}

export interface SaveCreateTeamEvent {
    type: TeamsViewMachineEvent.SAVE_NEW_TEAM;
    payload: string;
}

export interface CancelCreateTeamEvent {
    type: typeof TeamsViewMachineEvent.CANCEL_CREATE_TEAM;
}

export interface DeleteTeamEvent {
    type: typeof TeamsViewMachineEvent.DELETE_TEAM;
    payload: {
        team: UserGroup;
    };
}

export interface CancelDeleteTeamEvent {
    type: typeof TeamsViewMachineEvent.CANCEL_DELETE_TEAM;
}

export interface ConfirmDeleteTeamEvent {
    type: typeof TeamsViewMachineEvent.CONFIRM_DELETE_TEAM;
}

export type TeamsViewMachineEvents =
    | AddPeopleToTeamEvent
    | CollapseTeamEvent
    | ExpandTeamEvent
    | TeamSelectedForPersonAdditionEvent
    | UpdateTeamLeaderEvent
    | RequestUpdateTeamLeaderEvent
    | CancelTeamLeaderEvent
    | SetPersonForTeamRemovalEvent
    | RemovePersonFromTeamEvent
    | CreateTeamEvent
    | CancelCreateTeamEvent
    | SaveCreateTeamEvent
    | DeleteTeamEvent
    | CancelDeleteTeamEvent
    | ConfirmDeleteTeamEvent;
